import React, { useState, useEffect } from 'react';
import './Cursor.css';

const Cursor = () => {
  // Initialiser la position et l'état de survol
  const [position, setPosition] = useState({ x: -100, y: -100 });
  const [hover, setHover] = useState(false);
  
  useEffect(() => {
    // Gestionnaire de mouvement de souris
    const onMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };
    
    // Gestionnaires pour les survols
    const onMouseEnterLink = () => {
      setHover(true);
    };
    
    const onMouseLeaveLink = () => {
      setHover(false);
    };
    
    // Ajouter les écouteurs d'événements
    document.addEventListener('mousemove', onMouseMove);
    
    // Sélectionner tous les éléments interactifs
    const interactiveElements = document.querySelectorAll(
      'a, button, .hero-button, [role="button"], .side-nav-button, .filter-tag, .social-link'
    );
    
    // Ajouter les écouteurs d'événements à chaque élément interactif
    interactiveElements.forEach(el => {
      el.addEventListener('mouseenter', onMouseEnterLink);
      el.addEventListener('mouseleave', onMouseLeaveLink);
    });
    
    // Nettoyer lors du démontage
    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      
      interactiveElements.forEach(el => {
        el.removeEventListener('mouseenter', onMouseEnterLink);
        el.removeEventListener('mouseleave', onMouseLeaveLink);
      });
    };
  }, []); // Exécuter une seule fois au montage
  
  return (
    <>
      <div 
        className="cursor" 
        id="cursor"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`
        }}
        aria-hidden="true"
      />
      <div 
        className={`cursor2 ${hover ? 'hover' : ''}`} 
        id="cursor2"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`
        }}
        aria-hidden="true"
      />
      <div 
        className={`cursor3 ${hover ? 'hover' : ''}`} 
        id="cursor3"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`
        }}
        aria-hidden="true"
      />
    </>
  );
};

export default Cursor;